export default "__VITE_ASSET__CoQA6OvY__"